













import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Mixins
 */


/**
 * API
 */
import adminAPI from '@/api/admin';

/**
 * Components
 */



/**
 * Page de liste des fichiers MbeLog de synchronisation.
 */
@Component
export default class SynchroLogsListPage extends Vue {
	/** Attributs */
	isLoading = false;
	logsList: any[] | null = null;
	pagination = {
		sortBy: 'name',
		descending: true,
	};
	headers = [
		{
			text: 'logs.name',
			value: 'name',
			align: 'left'
		},
		{
			text: '',
			value: '',
			align: 'right'
		}
	];

	/** Méthodes */
	async created() {
		this.isLoading = true;
		await this.fetchAll();
		this.isLoading = false;
	}

	async fetchAll() {
		this.logsList = await adminAPI.getSynchroLogsList();
	}

	downloadFile(name: string) {
		adminAPI.downloadSynchroLogFile(name);
	}
}
